<template>
  <div>
    <form-build
      form-name="BankAccountEditForm"
      :form-rules="formRules"
      :form-buttons="formButtons"
      :form-columns-group="formColumnsGroup"
      :form-data="editForm"
    />
  </div>
</template>

<script>
  import FormBuild from '../../components/FormBuild'

  export default {
    name: "BankAccountEdit",
    data() {
      return {
        formRules: {
          ba__bank: [
            {
              required: true,
              message: '此项必填'
            }
          ],
          ba__branch: [
            {
              required: true,
              message: '此项必填'
            }
          ],
          ba__accountName: [
            {
              required: true,
              message: '此项必填'
            }
          ],
          ba__accountNo: [
            {
              required: true,
              message: '此项必填'
            }
          ],
        },
        formColumnsGroup: [{
          label: '银行账户信息',
          columns: [
            {
              label: '银行',
              field: 'ba__bank',
              component: 'el-input',
              type: 'text',
              span: 24
            },
            {
              label: '开户行',
              field: 'ba__branch',
              component: 'el-input',
              type: 'text',
              span: 24
            },
            {
              label: '户名',
              field: 'ba__accountName',
              component: 'el-input',
              type: 'text',
              span: 24
            },
            {
              label: '银行账号',
              field: 'ba__accountNo',
              component: 'el-input',
              type: 'text',
              span: 24
            }
          ]
        }],
        formButtons: [
          {
            label: '确定',
            type: 'primary',
            clickHandler: $refs=>{
              $refs.validate(valid=>{
                if(valid) {
                  this.$emit('onSubmit')
                }
              })
            }
          },
          {
            label: '取消',
            // type: '',
            clickHandler: $refs=> {
              this.$emit('onCancel')
            }
          }
        ]
      }
    },
    components: {
      FormBuild
    },
    props: {
      editForm: {
        type: Object,
        default:()=>{
          return {
            "ba__customerId": "",
            "ba__accountId": "",
            "ba__accountName": "",
            "ba__accountNo": "",
            "ba__bank": "",
            "ba__branch": ""
          }
        }
      }
    },
    computed: {
      form() {
        return this.editForm
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/BankAccountEdit.vue